import { useMemo } from "react";

export const LOGIN_GATE_PAGE_PROPERTY = "prm_core.login.gate_page";
export const DEFAULT_LOGIN_GATE_PAGE = "login";
export const PUBLIC_LOGIN_PREFIX = "/pub";

export const getSafeReturnTo = (value?: string | null) => {
    if (!value || typeof value !== "string") {
        return "/";
    }

    if (!value.startsWith("/") || value.startsWith("//")) {
        return "/";
    }

    const lowerValue = value.trim().toLowerCase();

    if (lowerValue.startsWith("/\\") || lowerValue.includes("javascript:")) {
        return "/";
    }

    return value;
};

export const buildCurrentReturnTo = () => {
    const { pathname, search, hash } = window.location;
    return `${pathname}${search}${hash}`;
};

export const buildPublicLoginPath = (page = DEFAULT_LOGIN_GATE_PAGE, returnTo?: string) => {
    const normalizedPage = encodeURIComponent(page || DEFAULT_LOGIN_GATE_PAGE);
    const params = new URLSearchParams();

    if (returnTo) {
        params.set("returnTo", getSafeReturnTo(returnTo));
    }

    const query = params.toString();
    return `${PUBLIC_LOGIN_PREFIX}/${normalizedPage}${query ? `?${query}` : ""}`;
};

export const isPublicLoginRoute = () => {
    return window.location.pathname.startsWith(`${PUBLIC_LOGIN_PREFIX}/`);
};

export const fetchLoginGatePage = async () => {
    return DEFAULT_LOGIN_GATE_PAGE;
};

export const redirectToConfiguredLogin = async (returnTo = buildCurrentReturnTo()) => {
    if (isPublicLoginRoute()) {
        return;
    }

    const loginPage = await fetchLoginGatePage();
    window.location.assign(buildPublicLoginPath(loginPage, returnTo));
};

export const useLoginGatePage = () => {
    return useMemo(() => ({
        data: DEFAULT_LOGIN_GATE_PAGE,
        isLoading: false,
    }), []);
};
